module.exports = __webpack_public_path__ + "static/media/img_Inscription_name1@2x.04a91348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_Inscription_name1@2x.png
// module id = 989
// module chunks = 0